import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../data/site";

export default function Menukaart() {
  return (
    <>
      <Seo
        title="Menukaart & Drankkaart | Mechelen Beach 2026"
        description="Bekijk de volledige drankkaart en het snackaanbod van Mechelen Beach 2026 — bieren, wijnen, cocktails, frisdranken, warme dranken en foodtrucks."
      />

      <PageHero
        eyebrow="Praktische info"
        title="Drankkaart"
        subtitle="Ontdek het volledige aanbod aan drankjes, snacks en foodtrucks op Mechelen Beach 2026."
        image={IMAGES.strandbarMain}
        imageAlt="Strandbar Mechelen Beach"
        primaryCta={{ label: "Openingsuren", to: "/praktische-info/openingsuren" }}
        secondaryCta={{ label: "Bereikbaarheid", to: "/praktische-info/bereikbaarheid" }}
      />

      <section className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="eyebrow">Editie 2026</span>
          <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
            Drankkaart
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
            Van bieren van &apos;t vat en Cornet flessen tot cocktails, mocktails,
            wijnen en warme dranken — hieronder vind je het volledige aanbod.
          </p>

          <div className="mt-8 bg-white rounded-2xl border border-[#ebd9b5] overflow-hidden shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)]">
            <img
              src="https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/6lfjklt3_Mechelen_Beach_Drankkaart_2026_resized.png"
              alt="Drankkaart Mechelen Beach 2026 — bieren, wijnen, cocktails, mocktails, frisdranken, warme dranken en foodtrucks"
              loading="lazy"
              data-testid="drankkaart-image"
              className="w-full h-auto object-contain"
            />
          </div>

          {/* FOODTRUCKS — menukaarten */}
          <div className="mt-14 sm:mt-16" data-testid="foodtrucks-section">
            <span className="eyebrow">Foodtrucks</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Menukaarten foodtrucks
            </h2>
            <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
              Ontdek het aanbod van onze foodtrucks op Mechelen Beach.
            </p>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
              <div data-testid="foodtruck-vet-content">
                <h3 className="font-display text-2xl sm:text-3xl font-semibold text-[#2b1c10]">
                  Vet Content
                </h3>
                <div className="mt-4 bg-white rounded-2xl border border-[#ebd9b5] overflow-hidden shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)]">
                  <img
                    src="https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/h31vaydu_Vet_Content_Menu_Foodtruck.png"
                    alt="Menukaart Vet Content foodtruck — burgers, snacks, patatten en om te delen"
                    loading="lazy"
                    data-testid="foodtruck-vet-content-image"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>

              <div data-testid="foodtruck-bubba-kroketten">
                <h3 className="font-display text-2xl sm:text-3xl font-semibold text-[#2b1c10]">
                  Bubba Kroketten
                </h3>
                <div className="mt-4 bg-white rounded-2xl border border-[#ebd9b5] overflow-hidden shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)]">
                  <img
                    src="https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/blzej8uc_Bubba_Menu_Mechelen_Beach.png"
                    alt="Menukaart Bubba Kroketten — aperomix, duokroketten, specials en gezonde hap"
                    loading="lazy"
                    data-testid="foodtruck-bubba-image"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/praktische-info/openingsuren" data-testid="menu-cta-openingsuren" className="btn-primary">
              Bekijk de openingsuren
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/strandbar" data-testid="menu-cta-strandbar" className="btn-ghost">
              Ontdek de strandbar
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
